export const courses = [
  {
    _id: 1,
    src: "https://i0.wp.com/mohirdev.uz/wp-content/uploads/2021/07/matrix-3408055_1280.jpg?resize=600%2C550&ssl=1",
    course: "Bepul Kurslar",
  },
  {
    _id: 2,
    src: "https://i0.wp.com/mohirdev.uz/wp-content/uploads/html-css-bootstrap-magnigeeks.png?resize=600%2C446&ssl=1",
    course: "HTML, CSS, Bootstrap",
  },
  {
    _id: 3,
    src: "https://i0.wp.com/mohirdev.uz/wp-content/uploads/2021/05/Untitled-design-5.png?resize=255%2C187&ssl=1",
    course: "React.JS",
  },
  {
    _id: 4,
    src: "https://i0.wp.com/mohirdev.uz/wp-content/uploads/Javascript-1.png?resize=500%2C300&ssl=1",
    course: "Javascript",
  },
  {
    _id: 5,
    src: "https://i0.wp.com/mohirdev.uz/wp-content/uploads/2021/05/Untitled-design-3.png?resize=255%2C187&ssl=1",
    course: "Python",
  },
  {
    _id: 6,
    src: "https://i0.wp.com/mohirdev.uz/wp-content/uploads/2021/05/Untitled-design-6.png?resize=255%2C187&ssl=1",
    course: "Mobile Dasturlash",
  },
  {
    _id: 7,
    src: "https://i0.wp.com/mohirdev.uz/wp-content/uploads/2020/01/skillate_cat-6.jpg?resize=255%2C187&ssl=1",
    course: "Web Dasturlash",
  },
  {
    _id: 8,
    src: "https://i0.wp.com/mohirdev.uz/wp-content/uploads/2020/01/skillate_cat3.jpg?resize=255%2C187&ssl=1",
    course: "Pullik Kurslar",
  },
];
